export type WallAppearance = { color: string; opacity: number; hidden?: boolean }
export type WallAppearances = Partial<Record<'A' | 'B' | 'C' | 'D', WallAppearance>>
export const DEFAULT_WALL_APPEARANCE: WallAppearance = { color: '#f3ebd9', opacity: 0.18 }
export function isWallAppearances(value: unknown): value is WallAppearances {
  return !!value && typeof value === 'object' && !Array.isArray(value) && Object.entries(value).every(([key, wall]) =>
    ['A','B','C','D'].includes(key) && wall && typeof wall === 'object' &&
    typeof wall.color === 'string' && /^#[\da-f]{6}$/i.test(wall.color) &&
    typeof wall.opacity === 'number' && Number.isFinite(wall.opacity) && wall.opacity >= 0 && wall.opacity <= 1 &&
    (wall.hidden === undefined || typeof wall.hidden === 'boolean'))
}
